import type { IndexFiltersProps } from '@shopify/polaris';

import { EReportColumnKey } from '~/presentation/reports/common/type';

export {
  ORDER_LISTING_COLUMNS,
  ORDER_LISTING_METRICS,
  ORDER_LISTING_METRIC_LAYOUTS,
  ORDER_LISTING_DIMENSIONS,
  ORDER_LISTING_DIMENSION_LAYOUT,
  ORDER_LISTING_CONFIG,
  SORT_ORDER_LISTING_DEFAULT,
} from '@gem-sdk/analytics';

export const ORDER_LISTING_ITEMS_PER_PAGE = 50;

// Order journey shows the GemX ID, so it must be fetched even when its column is hidden
export const ORDER_LISTING_REQUIRED_METRICS = [EReportColumnKey.GEMX_ID];

export const SORT_ORDER_LISTING: IndexFiltersProps['sortOptions'] = [
  { label: 'Date', value: `${EReportColumnKey.ORDER_DATE} asc`, directionLabel: 'Oldest first' },
  { label: 'Date', value: `${EReportColumnKey.ORDER_DATE} desc`, directionLabel: 'Newest first' },
  { label: 'Total', value: `${EReportColumnKey.TOTAL} asc`, directionLabel: 'Lowest to highest' },
  { label: 'Total', value: `${EReportColumnKey.TOTAL} desc`, directionLabel: 'Highest to lowest' },
];
